module.exports = __webpack_public_path__ + "img/times-solid.15490abb.svg";